<ngx-charts-line-chart
  [results]="ourMethodologyData"
  [legend]="false"
  [xAxis]="true"
  [yAxis]="true"
  [xAxisLabel]="'Sample Number'"
  [yAxisLabel]="'Cumulative Unique Answer Count'"
  [view]="chartView"
  [xAxisTicks]="xAxisTickValues"
  [roundDomains]="true"
  [animations]="true"
  [autoScale]="true"
  [timeline]="false">
</ngx-charts-line-chart>
<!-- <ngx-charts-line-chart
  [results]="[{ name: 'Average', series: averageLineData }]"
  [legend]="true"
  [xAxis]="true"
  [yAxis]="true"
  [view]="view"
  [legend]="true"
  [roundDomains]="true">
</ngx-charts-line-chart>
[animations]="true" -->